(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reducedMotion.matches) return;

  const hero = document.querySelector('.fab2-hero');
  if (hero) hero.classList.add('fab2-hero--intro');

  const revealSources = document.querySelectorAll('.fab2-products-promise, .fab2-mosaic, .fab2-faq-newsletter, .fab2-footer');
  const revealTargets = [];
  const seen = new Set();

  revealSources.forEach((source, index) => {
    const target = source.closest('.shopify-section') || source;
    if (seen.has(target)) return;

    seen.add(target);
    target.classList.add('fab2-reveal');
    target.style.setProperty('--fab2-reveal-delay', `${Math.min(index * 140, 560)}ms`);
    revealTargets.push(target);
  });

  if (revealTargets.length === 0) return;

  document.documentElement.classList.add('fab2-motion-ready');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    },
    {
      rootMargin: '0px 0px -8% 0px',
      threshold: 0.12
    }
  );

  revealTargets.forEach((target) => observer.observe(target));
})();
